<template>
  <div class="faq-item">
    <h2>{{ question }}</h2>
    <p>{{ answer }}</p>
  </div>
</template>

<script>
export default {
  name: "FAQItem",
  props: {
    question: String,
    answer: String
  }
};
</script>

<style lang="scss" scoped>
.faq-item {
  background-color: #eee;
  border-radius: var(--border-radius);
  padding: 0.1em 1em;
  margin-bottom: 20px;
}
</style>